<template>
  <div class="new-mini-program">
    <el-row gutter="12">
      <el-col span="8" offset="4">
        <el-card class="bind-exists-mini-program">
          <i class="el-icon-link"></i>
          <h3>微信注册小程序</h3><p class="hint">前往微信公众平台注册小程序</p>
          <el-link href="https://mp.weixin.qq.com/">
            <el-button type="primary">立即注册</el-button>
          </el-link>
        </el-card>
      </el-col>
      <el-col span="8">
        <el-card class="apply-new-mini-program">
          <i class="el-icon-document-add"></i>
          <h3>代注册小程序</h3>
          <p class="hint">
            <ol>
              <li>填写审核资料</li>
              <li>24小时内完成身份认证</li>
              <li>设置邮箱和密码</li>
            </ol>
          </p>
          <el-button @click="handleClickApplyNewMiniProgram">立即注册</el-button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class BindWechat extends Vue {
    handleClickApplyNewMiniProgram() {
      // 跳转到快速创建小程序表单录入页面
      this.$router.push({ name: 'mini_program_register' });
    }
  }
</script>

<style lang="scss">
  .new-mini-program {
    text-align: center;

    .el-row {
      margin-top: 100px;
      .el-button {
        padding: 15px 30px;

        span {
          font-size: 15px;
        }
      }
    }

    .info {
      margin-top: 50px;

      .el-button {
        width: 100%;
      }
    }

    .el-icon-link, .el-icon-document-add {
      font-size: 100px;
      font-weight: 500;
      display: block;
      color: #8a8a8a;
    }

    .el-card {
      text-align: center;
    }

    .apply-new-mini-program {
      .el-button > span {
        color: $primary;
      }
    }

    .hint {
      height: 120px;
      color: #adadad;
      ol {
        width: auto;
        text-align: left;
        margin-left: 26%;
      }
    }
  }
</style>
